import { useState, useEffect } from 'react';
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import MoneyIcon from '@material-ui/icons/Money';
import { red, green } from '@material-ui/core/colors';
import { Button } from '@material-ui/core';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { getAdmins, uploadImage, addCashInvestment } from '../../redux/actions/admin.actions';


//My Components
import AddCash from '../../testComponents/addCashModal';
import { getCashTransactions } from 'src/redux/actions/admin.actions';

const Budget = (props) => {
  const dispatch = useDispatch();

  const { cashTransactions: { cashAvailable, cashInvestment  }, cashTransactions } = useSelector(state => state.data);

  const [values, setValues] = useState({
    cashInvestments: 0,
    cashAvailable: 0
  })

  const handleGetCash = async () => {
 
  await dispatch(getCashTransactions())
    .catch(err => {

    })


  }


useEffect(() => {
  handleGetCash();
}, [])

useEffect(() => {
  setValues(cashTransactions)
}, [cashAvailable, cashInvestment])
  console.log(cashTransactions)
  
  return (
  <Card
    // sx={{ height: '100%' }}
    {...props}
  >
    <CardContent>
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
          <Typography
            color="textSecondary"
            gutterBottom
            variant="body2"
          >
            Cash Investment
          </Typography>
          <Typography
            color="primary"
            variant="h6"
            className="mb-3"
          >
            ₱ {values.cashInvestment}
          </Typography>
          <Typography
            color="textSecondary"
            gutterBottom
            variant="body2"
          >
            Cash Available
          </Typography>
          <Typography
            color="primary"
            variant="h6"
          >
            ₱ {values.cashAvailable}
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: green[600],
              height: 56,
              width: 56
            }}
          >
            <MoneyIcon />
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
    <Divider/>
    <CardActions style={{
       display: 'flex',
       alignItems: 'center',
       justifyContent: 'center',
    }}>
     <AddCash/>
    </CardActions>
  </Card>
);
  }
export default Budget;
